import { render } from "./DirectMessage.vue?vue&type=template&id=56b016ee"
import script from "./DirectMessage.vue?vue&type=script&lang=js"
export * from "./DirectMessage.vue?vue&type=script&lang=js"

import "./DirectMessage.vue?vue&type=style&index=0&id=56b016ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__